import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
import { ScFieldsFragmentDoc, ScWithMinMaxFieldsFragmentDoc } from './share-class.graphql';
import { ValidatorStatusFieldsFragmentDoc } from './validator-status.graphql';
export type GqlWppFieldsFragment = { claim?: string | null, createdAt: string, forcedRedemption: boolean, forcedSaleAtIpo: boolean, id: string, identityId: string, optionsRegistrationId: string, paymentKind: number, paymentStatus: number, quantity?: string | null, repurchaseVested: boolean, updatedAt: string, vestingAcceleration: boolean, vestingCliffDuration: number, vestingDuration: number, vestingFrequency: number, vestingKind: number, vestingEndDate?: string | null, leaveOfAbsenceDays: number, leaveOfAbsence: boolean, shareClass: { name: string, voteWeight: string, quantity?: string | null } };

export type GqlWppValidatorErrorFieldsFragment = { paymentStatus: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, cliff: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, proxy: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null } };

export type GqlVestingOccasionFieldsFragment = { id: string, warrantParticipantId: string, quantity: string, vestingDate?: string | null, descriptionPrimaryLang?: string | null, descriptionSecondaryLang?: string | null, requirementPrimaryLang?: string | null, requirementSecondaryLang?: string | null, sortOrder: number, isValid: boolean, totalVested?: string | null, status: Types.GqlVestingOccasionStatus };

export const WppFieldsFragmentDoc = gql`
    fragment WppFields on WarrantParticipant {
  claim
  createdAt
  forcedRedemption
  forcedSaleAtIpo
  id
  identityId
  optionsRegistrationId
  paymentKind
  paymentStatus
  quantity
  repurchaseVested
  shareClass {
    ...ScFields
  }
  updatedAt
  vestingAcceleration
  vestingCliffDuration
  vestingDuration
  vestingFrequency
  vestingKind
  vestingEndDate
  leaveOfAbsenceDays
  leaveOfAbsence
}
    ${ScFieldsFragmentDoc}`;
export const WppValidatorErrorFieldsFragmentDoc = gql`
    fragment WppValidatorErrorFields on WppValidatorErrors {
  paymentStatus {
    ...ValidatorStatusFields
  }
  cliff {
    ...ValidatorStatusFields
  }
  proxy {
    ...ValidatorStatusFields
  }
}
    ${ValidatorStatusFieldsFragmentDoc}`;
export const VestingOccasionFieldsFragmentDoc = gql`
    fragment VestingOccasionFields on WarrantParticipantVestingOccasion {
  id
  warrantParticipantId
  quantity
  vestingDate
  descriptionPrimaryLang
  descriptionSecondaryLang
  requirementPrimaryLang
  requirementSecondaryLang
  sortOrder
  isValid
  totalVested
  status
}
    `;